/**
 * Sorts items by:
 *   1) position in `primary` (if present),
 *   2) then `secondary` (if present),
 *   3) then alphabetically.
 */
export function sortByPriorities<T>(
  items: T[],
  extractKey: (item: T) => string, // eslint-disable-line no-unused-vars
  primary: string[],
  secondary?: string[]
): T[] {
  if (items.length === 0) {
    return [];
  }

  return [...items].sort((a, b) => {
    const keyA = extractKey(a);
    const keyB = extractKey(b);

    // 1) Primary
    const priA = primary.indexOf(keyA);
    const priB = primary.indexOf(keyB);
    if (priA !== -1 || priB !== -1) {
      if (priA === -1) return 1;
      if (priB === -1) return -1;
      return priA - priB;
    }

    // 2) Secondary
    if (secondary) {
      const secA = secondary.indexOf(keyA);
      const secB = secondary.indexOf(keyB);
      if (secA !== -1 || secB !== -1) {
        if (secA === -1) return 1;
        if (secB === -1) return -1;
        return secA - secB;
      }
    }

    // 3) Fallback to alphabetical
    return keyA.localeCompare(keyB);
  });
}
